import { request } from "@/api";
import type { NotificationItem } from "@/shared/types";

interface NotyParams {
  limit?: number;
  offset?: number;
}

export const fetchNotifications = async (params?: NotyParams) => {
  return request<NotificationItem[]>("/notifications", {
    params,
  });
};
